export const CUSTOMER_AUTH_ROUTES = {
  LOGIN: "api/v1/customer/login",
  SIGNUP: "api/v1/customer/signup",
  CUSTOMER_DETAILS: "api/v1/user/details",
  VERIFY: "api/v1/customer/verify",
  REVERIFY: "api/v1/customer/resend-verify",
  CHANGE_PASSWORD: "api/v1/customer/change-password",
  RESET_PASSWORD: "api/v1/customer/reset-password",
  CUSTOMER_FP_SENDMAIL: "api/v1/customer/forgot-password",
};

export const DROPDOWN_ROUTES = {
  GET_STATES: "api/v1/customer/dropdown/states",
  GET_CITY_BY_STATE_ID: "api/v1/customer/dropdown/cities",
  GET_AREA_BY_CITY_ID: "api/v1/customer/dropdown/area",
  GET_ALL_FACT_FEATURES: "api/v1/customer/fact-and-feature",
  GET_AMENITIES: "api/v1/customer/dropdown/amenties",
  GET_FACILITIES: "api/v1/customer/dropdown/facilites",
  GET_ALL_CATEGORY: "api/v1/user/categories",
  GET_IMAGE_CATEGORY: "api/v1/customer/image/categories",
  GET_SUB_CATEGORY_CATEGORY_ID: "api/v1/customer/sub-category",
};

export const CUSTOMER_HOME_ROUTES = {
  HOMES_FOR_YOU: "api/v1/customer/homes-for-you",
  FEATURED_PROPERTY: "api/v1/customer/featured-properties",
  FEATURED_PROJECT: "api/v1/customer/featured-projects",
  LATEST_PROJECT: "api/v1/customer/latest-projects",
  HOME_SEARCH: "api/v1/customer/home-search",
  SEARCH_PROPERTY: "api/v1/customer/search-property",
  GET_PROJECTS: "api/v1/customer/get-projects",
  SINGLE_PROJECTS: "api/v1/customer/project-details",
  NEWS_LETTER_SUBSCRIBE: "api/v1/customer/subscribe",
};

export const CUSTOMER_HOME_BLOGS = {
  GET_BLOGS: "api/v1/customer/blog",
};

export const CUSTOMER_NOTIFICATIONS = {
  GET_NOTIFICATIONS_LIST: "api/v1/customer/get-all-notification",
};

export const CUSTOMER_CMS = {
  GET_CMS: "api/v1/customer/cms",
  GET_FAQS: "api/v1/customer/faqs",
};

export const CUSTOMER_CONTACT_US = {
  CREATE: "/api/v1/customer/contact-us",
};

export const CUSTOMER_PROPERTY_ROUTES = {
  GET_PROPERTY_DETAIL: "api/v1/customer/property-details",
  CONTACT_US: "api/v1/customer/enquiry",
  FEEDBACK: "api/v1/customer/feedback",
  SAVE_PROPERTY: "api/v1/customer/properties/save-property",
  UNSAVE_PROPERTY: "api/v1/customer/properties/unsave-property",
  SAVED_PROPERTIES: "api/v1/customer/properties/saved-properties/list",
  RECENTLY_VIEWD: "api/v1/customer/recently-viewed",
  CLEAR_RECENTLY_VIEWD: "api/v1/customer/clear-recently-viewed",
  PURCHASED_PROPERTIES: "api/v1/customer/purchased-properties",
  PROPERTY_IMAGES_LABEL: "api/v1/customer/properties/images",
  PROPERTY_IMAGE_POSITION: "api/v1/customer/properties/images/position",
};

export const CUSTOMER_AGENT_ROUTES = {
  RATING: "api/v1/customer/review",
};

export const CUSTOMER_PROJECT_ROUTES = {
  SAVE_PROJECT: "api/v1/customer/projects/save-project",
  UNSAVE_PROJECT: "api/v1/customer/projects/unsave-project",
  SAVED_PROJECTS: "api/v1/customer/projects/saved-projects/list",
  RELATED_PROPERTIES: "api/v1/customer/properties-by-project",
  PROJECT_IMAGES: "api/v1/customer/projects/images",
  PROJECT_IMAGE_POSITION: "api/v1/customer/projects/images/position",
};

export const CUSTOMER_MEETING_ROUTES = {
  GET_DATES: "api/v1/customer/get-dates",
  GET_SLOTS: "api/v1/customer/get-slots",
  SET_MEETING: "api/v1/customer/set-meeting",
  GET_MEETING: "api/v1/customer/get-meeting",
  CANCEL_MEETING: "api/v1/customer/cancel-meeting",
};

export const CUSTOMER_PROFILE = {
  UPDATE_CUSTOMER: "api/v1/customer/user-profile",
};

export const CUSTOMER_SELLER_PROPERTY_ROUTES = {
  ADD_PROPERTY: "api/v1/customer/properties",
  ADD_PROPERTY_IMAGE: "api/v1/customer/properties/images",
  DELETE_PROPERTY_IMAGE: "api/v1/customer/properties/images/delete",
  UPLOAD_RERA_DOCUMENT: "api/v1/customer/properties/rera-document",
  GET_ALL_PROPERTIES: "api/v1/customer/my-properties",
  ARCHIVED_PROPERTIES: "api/v1/customer/archived-properties",
  DELETE_PROPERTY: "api/v1/customer/delete-property",
  GET_PROPERTY_DETAIL: "api/v1/customer/property-details",
};

export const CUSTOMER_SELLER_PROJECT_ROUTES = {
  GET_ALL_PROJECT: "api/v1/customer/my-projects",
  ARCHIVED_PROJECTS: "api/v1/customer/archived-projects",
  CREATE_PROJECT: "api/v1/customer/projects",
  PROJECT_IMAGES: "api/v1/customer/projects/images",
  UPLOAD_RERA_DOCUMENT: "api/v1/customer/projects/rera-document",
};

export const CUSTOMER_SLIDER_ROUTES = {
  GET_ALL_SLIDER: "api/v1/customer/slider",
};

export const CUSTOMER_REPORT_ROUTES = {
  ADD_REPORT: "api/v1/customer/report",
};

export const ADVERTISE_ROUTERS = {
  ADD_ADVERTISE: "api/v1/customer/advertise",
};

export const SALES_DATA_ROUTER = {
  CREATE: "api/v1/customer/sales-data",
  SALES_MEMBER: "api/v1/customer/sales-members",
};

export const CUSTOMER_GROUP_NAME_ROUTES = {
  GET_ALL_GROUPS: "api/v1/customer/group-name",
};

export const CUSTOMER_REEL_ROUTES = {
  REELS_FEED: "api/v1/customer/reels-feed",
  REEL: "api/v1/customer/reel-details",
  REEL_LIKE: "api/v1/customer/reels-like",
  REEL_VIEW: "api/v1/customer/reels-view",
};

export const CUSTOMER_SEO_ROUTES = {
  GET: "api/v1/customer/seo",
};
